import PublicationTypes from "constants/publication-types";
import PublicationComponentType from "utilities/enumerations/publication-component-type";
import EnhancedContentChapterManifestsService from "utilities/services/enhanced-content/enhanced-content-chapter-manifests-service";
import StringUtils from "utilities/string-utils";

interface UseEnhancedContentManifestOptions {
    publicationComponent:
        | {
              type: PublicationComponentType;
              nfpaLabel?: string;
          }
        | undefined;
    code: string | undefined;
    edition: string | undefined;
    publicationType: PublicationTypes | undefined;
    disabled: boolean | undefined;
    externalId: string | undefined;
}
const STALE_TIME = 5 * 60 * 1000; // 5 minutes

const useEnhancedContentManifest = (
    options: UseEnhancedContentManifestOptions
) => {
    const {
        publicationComponent,
        code,
        edition,
        publicationType,
        disabled = false,
        externalId,
    } = options;
    const shouldSkipChapterManifests =
        publicationComponent?.type === PublicationComponentType.Chapter &&
        publicationType === PublicationTypes.NEC;
    const hasManifestData =
        StringUtils.hasValue(code) &&
        StringUtils.hasValue(edition) &&
        StringUtils.hasValue(publicationComponent?.nfpaLabel) &&
        publicationComponent?.type != null;

    const enableManifestQuery =
        !disabled && hasManifestData && !shouldSkipChapterManifests;

    const { list: listEnhancedContentManifests } =
        EnhancedContentChapterManifestsService.useListQuery();
    const { data: enhancedContentManifests, refetch: refetchManifests } =
        listEnhancedContentManifests(
            {
                code: code!,
                edition: edition!,
            },
            {
                publicationComponentType: publicationComponent?.type!,
                nfpaLabel: publicationComponent?.nfpaLabel!,
            },
            {
                enabled: enableManifestQuery,
                staleTime: STALE_TIME,
            }
        );

    const currentEnhancedContentManifest =
        enhancedContentManifests?.resultObjects.find(
            (element) => element.externalId === externalId
        ) ?? null;

    return {
        refetchManifests,
        currentEnhancedContentManifest,
    };
};

export default useEnhancedContentManifest;
